export const TOGGLE_SHOW_ARCHIVED_SCENARIOS = 'SCENARIO:TOGGLE_SHOW_ARCHIVED_SCENARIOS';
